import { Row, Col, Button } from "react-bootstrap";
import ImageBackground from '../ImageBackground.jsx'

const QuatreBoutonsAccueil = ({
    showAlreadyVoted,
    asAlreadyVoted,
    interaction,
    isImageBlur,
    verifyAsAlreadVoted,
    demanderEnregistrement,
    textBTNParticiper,
    changerAfficherEtapeCollecteParticipationVoix,
    changerAfficherEtapeCollecteParticipationTexte,
    changerAfficherEtapeCollecteParticipationImage,
}) => {
return (
    <div className="accueil">
        {showAlreadyVoted &&
            <>
                <div className={asAlreadyVoted}  >Désolé, <br />
                    Vous êtes limité à une <br />
                    participation pour cette <br />
                    événement
                </div>
            </>
        }
        <Row className="home-background text-center">
            <Col>
                <ImageBackground interaction={interaction} isImageBlur={isImageBlur} />
            </Col>
        </Row>
        <div className="bouton-bfm bfm-bouton-sans-picto bfm-bouton-largeur-accueil">
            <Row className="custom-commandes">
                <Col xs={6}>
                    <Button onClick={e => verifyAsAlreadVoted(demanderEnregistrement)}>{textBTNParticiper}</Button>
                </Col>
                <Col xs={6}>
                    <Button onClick={e => verifyAsAlreadVoted(changerAfficherEtapeCollecteParticipationImage)}>Envoyer une photo</Button>
                </Col>
            </Row>
            <Row className="custom-commandes bfm-quatre-bouton-accueil-ligne2">
                <Col xs={6}> 
                    <Button onClick={e => verifyAsAlreadVoted(changerAfficherEtapeCollecteParticipationVoix)}><span>Envoyer un vocal</span></Button>
                </Col>
                <Col xs={6}>
                    <Button onClick={e => verifyAsAlreadVoted(changerAfficherEtapeCollecteParticipationTexte)}><span>Participer par écrit</span></Button>
                </Col>
            </Row>
        </div>
 
    </div>
)};
export default QuatreBoutonsAccueil;